export function u8(b: Uint8Array, off: number): number {
  const v = b[off];
  if (v === undefined) throw new RangeError(`read past end at 0x${off.toString(16)}`);
  return v;
}

export function u16be(b: Uint8Array, off: number): number {
  return (u8(b, off) << 8) | u8(b, off + 1);
}

export function u24be(b: Uint8Array, off: number): number {
  return (u8(b, off) << 16) | (u8(b, off + 1) << 8) | u8(b, off + 2);
}

export function setU8(b: Uint8Array, off: number, v: number): void {
  if (off < 0 || off >= b.length) throw new RangeError(`write past end at 0x${off.toString(16)}`);
  b[off] = v & 0xff;
}

export function setU16be(b: Uint8Array, off: number, v: number): void {
  setU8(b, off, v >>> 8);
  setU8(b, off + 1, v);
}

export function setU24be(b: Uint8Array, off: number, v: number): void {
  setU8(b, off, v >>> 16);
  setU8(b, off + 1, v >>> 8);
  setU8(b, off + 2, v);
}

export function slice(b: Uint8Array, off: number, len: number): Uint8Array {
  if (off < 0 || off + len > b.length) throw new RangeError(`slice 0x${off.toString(16)}+${len} out of range`);
  return b.slice(off, off + len);
}

export function bytesEqual(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
  return true;
}

export function hexToBytes(hex: string): Uint8Array {
  const h = hex.startsWith("0x") ? hex.slice(2) : hex;
  if (h.length % 2 !== 0 || !/^[0-9a-fA-F]*$/.test(h)) throw new Error(`invalid hex string`);
  const out = new Uint8Array(h.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(h.slice(i * 2, i * 2 + 2), 16);
  return out;
}

export function bytesToHex(b: Uint8Array): string {
  let s = "";
  for (const v of b) s += v.toString(16).padStart(2, "0");
  return s;
}
